export default __webpack_public_path__ + "static/media/icon-insights-discount.af85dfb6.svg";